import MergetagInput from '@Components/Mergetag/Input'

import FormComponent from './FormComponent'

export default class MergetagInputForm extends FormComponent {
  static Pure = ({ onChange, ...props }) => <MergetagInput
    {...props}
    onChange={value => onChange(value)}
  />
}

MergetagInputForm.extendDefaultProps = {
  defaultClassName: 'form-control',
}
